import axios from "@/plugins/axios";

export default {
  uploadToDb(data) {
    return axios.post("/dbupload", data);
  },
};
